import styled from 'styled-components';
import { Table } from 'react-bootstrap';

export const BTableWrapper = styled(Table)`
    border-collapse: collapse;
    margin-bottom: 0px;

    & > thead > tr > th {
        text-align: center;
        padding: 4px;
    }

    & > thead > tr > th.th-recipient {
        background-color: #ddd;
        border: 1px solid white;
    }

    & > thead > tr > th.th-donor {
        background-color: lightblue;
        border: 1px solid white;
    }

    & > tbody > tr > td {
        text-align: center;
        padding: 4px;
    }
`;

export const TableWrapper = styled(Table)`
    & > thead > tr > th {
        background-color: #ddd;
        border-color: white;
        cursor: default;
    }

    & > thead > tr > th,
    & > tbody > tr > td {
        text-align: center;
        vertical-align: middle;
    }

    .recipient-header {
        background-color: #2D6CA2;
        color: #FFF;
        border-right: 1px solid white;
    }

    .donor-header {
        background-color: #2D6CA2;
        color: #FFF;
    }

    .th-recipient {
        background-color: #ddd;
        border-color: white white #ddd white;
        border-width: 1px 1px 0px 0px;
        border-style: solid;
        padding: 0.7rem 0.5rem !important;
        height: 32px;
    }

    .th-donor {
        background-color: #ddd;
        border-color: white white #ddd white;
        border-width: 1px 1px 0px 0px;
        border-style: solid;
        padding: 0.7rem 0.5rem !important;
        height: 32px;
    }

    .th-sortable {
        cursor: default;
    }

    .th-sortable > div {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .th-sortable:hover {
        text-decoration: underline;
    }

    .hla-info {
        cursor: default;
    }

    .hla-info:hover {
        text-decoration: underline;
    }
`;

export const Styles = styled.div`
    padding: 1rem;

    .table {
        display: inline-block;
        border-spacing: 0;
        // border: 1px solid black;

        // .tr {
        //     :last-child {
        //     .td {
        //         border-bottom: 0;
        //     }
        // }
    
        .th,
        .td {
            margin: 0;
            padding: 0.5rem;
            text-align: center;
            // border-bottom: 1px solid black;
            // border-right: 1px solid black;

            :last-child {
                // border-right: 1px solid black;
            }
        }

        
    }

    .tr > .td {
        border-color: #ddd;
        border-width: 1px 1px 1px 0px;
        border-style: solid;
    }

    .tr:last-child .td {
        border-color: #ddd;
        border-width: 0px 1px 1px 0px;
        border-style: solid;
    }

    .th-recipient-top {
        background-color: #2D6CA2;
        color: #FFF;
        border-right: 1px solid white;
    }

    .th-donor-top {
        background-color: #2D6CA2;
        color: #FFF;
    }

    .th-recipient {
        background-color: #ddd;
        border-color: white white #ddd white;
        border-width: 1px 1px 0px 0px;
        border-style: solid;
        padding: 0.7rem 0.5rem !important;
        height: 32px;
        font-weight: bold;
    }

    .th-donor {
        background-color: #ddd;
        border-color: white white #ddd white;
        border-width: 1px 1px 0px 0px;
        border-style: solid;
        padding: 0.7rem 0.5rem !important;
        height: 32px;
        font-weight: bold;
    }

    .th-actions {
        // border-bottom: 1px solid #ccc;
    }

    div[role='rowgroup'] {
        border-width: 1px;
        border-color: #ccc #ccc #ccc #ccc;
        border-style: solid;
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
    }
`;